import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath = "page.4uBus.register.iService.";

export const ShiftLIS = memo(() => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Typography variant="body2">
        {t(translationPath + "configuration_under_development")}
      </Typography>
    </Grid>
  );
});
